module.exports = __webpack_public_path__ + "img/movil5.ec148f03.jpg";